export default function copyToClipboard(contents: string) {
  navigator.clipboard.writeText(contents)
}
